import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AppSiteComponent } from './app-site.component';
import { AuthGuard } from './core/guards/auth.guard';
import { HomeGuard } from './core/guards/home.guard';
import { HybridRoutingGuard } from './core/guards/hybrid-routing.guard';
import { RootPathRedirectGuard } from './core/guards/root-path-redirect.guard';
import { VerityGuard } from './core/guards/verity.guard';
import { PageNotFoundComponent } from './pages/pageNotFound/pageNotFound.component';

const routes: Routes = [
    {
        path: 'panel',
        loadChildren: () => import('./pages/panel/panel.module').then((m) => m.PanelModule),
        data: { title: 'DASHBOARD.DASHBOARD', icon: 'dashboard' },
        canActivate: [AuthGuard, HybridRoutingGuard, VerityGuard],
    },
    {
        path: 'projects',
        loadChildren: () => import('./pages/projects/projects.module').then((m) => m.ProjectsModule),
        data: { title: 'NAVBAR.PROJECTS', icon: 'project' },
        canActivate: [AuthGuard, HybridRoutingGuard, VerityGuard],
    },
    {
        path: 'layers',
        loadChildren: () => import('./pages/layers/layers.module').then((m) => m.LayersModule),
        data: { title: 'NAVBAR.LAYERS', icon: 'layer' },
        canActivate: [AuthGuard, HybridRoutingGuard, VerityGuard],
    },
    {
        path: 'sites',
        loadChildren: () => import('./pages/job-sites/job-sites.module').then((m) => m.JobSitesModule),
        data: { title: 'NAVBAR.JOB_SITE', icon: 'dozer' },
        canActivate: [AuthGuard, HybridRoutingGuard, VerityGuard],
    },
    {
        path: 'admin/authorization',
        loadChildren: () => import('./pages/admin-authorization/admin-authorization.module').then((m) => m.AdminAuthorizationModule),
        data: { title: 'NAVBAR.USER_ADMIN', icon: 'group' },
        canActivate: [AuthGuard, HybridRoutingGuard, VerityGuard],
    },
    {
        path: 'reports',
        loadChildren: () => import('./pages/reports/reports.module').then((m) => m.ReportsModule),
        data: { title: 'NAVBAR.REPORTS', icon: 'report' },
        canActivate: [AuthGuard, HybridRoutingGuard, VerityGuard],
    },
    {
        path: 'jobs',
        loadChildren: () => import('./pages/jobs/jobs-panel.module').then((m) => m.JobsModule),
        data: { title: 'NAVBAR.JOBS', icon: 'task' },
        canActivate: [AuthGuard, HybridRoutingGuard, VerityGuard],
    },
    {
        path: 'process',
        loadChildren: () => import('./pages/process-panel/process-panel.module').then((m) => m.ProcessPanelModule),
        data: { title: 'NAVBAR.JOBS', icon: 'task' },
        canActivate: [AuthGuard, HybridRoutingGuard, VerityGuard],
    },
    {
        path: 'events-log',
        loadChildren: () => import('./pages/events-log/events-log.module').then((m) => m.EventsLogModule),
        data: { title: 'NAVBAR.EVENTS_LOG', icon: 'calendar' },
        canActivate: [AuthGuard, HybridRoutingGuard, VerityGuard],
    },
    {
        path: 'support',
        loadChildren: () => import('./pages/support/support.module').then((m) => m.SupportModule),
        data: { title: 'NAVBAR.SUPPORT', icon: 'gears' },
        canActivate: [AuthGuard, HybridRoutingGuard, VerityGuard],
    },
    {
        path: 'embed.html',
        loadChildren: () =>
            import('./pages/project-viewer-container/project-viewer-container.module').then((m) => m.ProjectViewerContainerModule),
        data: { title: '', icon: '' },
        canActivate: [AuthGuard, HybridRoutingGuard],
    },
    {
        path: 'viewer/:projectId',
        loadChildren: () =>
            import('./pages/project-viewer-container/project-viewer-container.module').then((m) => m.ProjectViewerContainerModule),
        data: { title: '', icon: '' },
        canActivate: [AuthGuard, HybridRoutingGuard, VerityGuard],
    },
    {
        path: 'scan-viewer/:projectId',
        loadChildren: () =>
            import('./pages/project-viewer-container/project-viewer-container.module').then((m) => m.ProjectViewerContainerModule),
        data: { title: '', icon: '' },
        canActivate: [AuthGuard, HybridRoutingGuard, VerityGuard],
    },
    {
        path: 'site-viewer/:jobSiteId',
        loadChildren: () =>
            import('./pages/job-site-viewer-container/job-site-viewer-container.module').then((m) => m.JobSiteViewerContainerModule),
        data: { title: '', icon: '' },
        canActivate: [AuthGuard, HybridRoutingGuard, VerityGuard],
    },
    {
        path: 'home',
        loadChildren: () => import('./pages/home/home.module').then((m) => m.HomeModule),
        data: { title: '', icon: '' },
        canActivate: [HomeGuard, HybridRoutingGuard, VerityGuard],
    },
    {
        /* When the path is /logout the AppSiteComponent will clear the credentials and navigate to the home of the app */
        path: 'logout',
        component: AppSiteComponent,
    },
    {
        path: '',
        pathMatch: 'full',
        canActivate: [RootPathRedirectGuard],
        // Redirect will never allow loading the component below
        component: PageNotFoundComponent,
    },

    {
        path: '**',
        component: PageNotFoundComponent,
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
